import _extends from "@babel/runtime/helpers/esm/extends";
import * as React from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
var CloudSun02 = function CloudSun02(props) {
  return /*#__PURE__*/_jsx("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props, {
    children: /*#__PURE__*/_jsx("path", {
      stroke: "currentColor",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2,
      d: "M10.5 1.5v1.6M3.6 10H2m3.4512-5.0486L4.3198 3.82m11.23 1.1314L16.6812 3.82M19 10h-1.6m-10.9.0001c0-2.2092 1.791-4 4.0001-4 1.506 0 2.8176.8323 3.5 2.062M6 22c-2.2091 0-4-1.7909-4-4s1.7909-4 4-4c.4642 0 .91.0791 1.3244.2245C8.0406 12.3396 9.864 11 12 11s3.9594 1.3396 4.6756 3.2245A4 4 0 0 1 18 14c2.2091 0 4 1.7909 4 4s-1.7909 4-4 4z"
    })
  }));
};
export default CloudSun02;